var A = /* @__PURE__ */ ((E) => (E[E.DATE = 0] = "DATE", E[E.DAY_OF_WEEK = 1] = "DAY_OF_WEEK", E[E.MONTH_HEADER = 2] = "MONTH_HEADER", E))(A || {});
export {
  A as CalendarGridRenderToken
};
